import { __assign, __read, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useOverrides } from '../overrides';
import { styled } from '../style';
var StyledBox = styled('div');
var Box = forwardRef(function (props, ref) {
    var _a = props.overrides, overrides = _a === void 0 ? {} : _a, boxProps = __rest(props, ["overrides"]);
    var _b = __read(useOverrides(overrides.Box, StyledBox), 2), Comp = _b[0], overrideProps = _b[1];
    return _jsx(Comp, __assign({ "data-spaceweb": "box", "data-testid": "box" }, boxProps, overrideProps, { ref: ref }), void 0);
});
Box.displayName = 'Box';
export default Box;
